// src/utils/logEvent.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";

const db = getFirestore(firebaseApp);

/**
 * Log any action to the audit trail
 * @param {string} action     → e.g. "User Created", "Lease Updated", "User Logged In"
 * @param {string} target     → e.g. user email, lease ID, property name
 * @param {string} type       → e.g. "User Management", "Lease", "Login/Logout"
 */
export async function logEvent(action, target = "", type = "General") {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  const event = {
    date: Math.floor(Date.now() / 1000),           // Unix timestamp
    timestamp: serverTimestamp(),                  // For perfect sorting
    eventType: type,
    eventAction: action,
    user: currentUser.mobile || currentUser.email || "Unknown",
    userName: `${currentUser.name || ""} ${currentUser.lastname || ""}`.trim() || "Unknown",
    targetEmail: target,
    targetId: target.includes("@") ? "" : target,  // optional
  };

  try {
    await addDoc(collection(db, "events"), event);
  } catch (e) {
    console.error("Failed to log event:", e);
  }
}